import { useState, useEffect } from "react"


const useStore = (indexOperation, request, shouldAutoLoad = true, parameters = {}, dependencies = []) => {
  const [ items, setItems ] = useState()

  let isInProgress = false
  useEffect(() => {
    if (isInProgress) { return }
    isInProgress = true

    if (!shouldAutoLoad) { return }

    indexItems()
  }, dependencies)

  const resetItems = () =>
    setItems()

  const addItem = newItem =>
    setItems(prevItems => [ newItem, ...prevItems ])

  const getItem = (id) =>
    (items || []).find(item => item.id === id)

  const indexItems = () =>
    request(indexOperation, parameters)
      .then(({ data }) => setItems(data))

  const updateItem = updatedItem =>
    setItems((prevItems = []) =>
      prevItems.map(item => ({
        ...(item.id === updatedItem.id ? updatedItem : item)
      }))
    )

  const removeItem = id =>
    setItems(prevItems => [
      ...prevItems.filter(item => item.id !== id)
    ])

  return {
    items,
    getItem,
    addItem,
    setItems,
    removeItem,
    resetItems,
    indexItems,
    updateItem,
  }
}

export default useStore
